// OMNIA Analytics — beacon de primera parte (self-hosted). Envía vistas y eventos
// al backend, con cookies (visitante/sesión) y, si hay sesión, el token para atribuir
// demografía. No bloquea la UI (best-effort).
import { API } from "./api";

export function track(event = "pageview", props = {}, pathOverride) {
  try {
    const path = pathOverride || (window.location.pathname + window.location.search);
    const scope = path.startsWith("/os") ? "app" : "public";
    const token = localStorage.getItem("omnia_token");
    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;
    const body = JSON.stringify({
      path,
      referrer: document.referrer || "",
      title: document.title || "",
      scope,
      event,
      props,
    });
    fetch(`${API}/analytics/collect`, { method: "POST", headers, body, credentials: "include", keepalive: true }).catch(() => {});
  } catch (e) { /* noop */ }
}

export function trackPageview() {
  track("pageview");
}
